import { render, staticRenderFns } from "./layout-brands-carousel.vue?vue&type=template&id=b1bbfba6&scoped=true"
import script from "./layout-brands-carousel.vue?vue&type=script&lang=js"
export * from "./layout-brands-carousel.vue?vue&type=script&lang=js"
import style0 from "./layout-brands-carousel.vue?vue&type=style&index=0&id=b1bbfba6&prod&lang=scss&scoped=true"
import style1 from "./layout-brands-carousel.vue?vue&type=style&index=1&id=b1bbfba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bbfba6",
  null
  
)

export default component.exports